import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const Alert: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 465.842 465.842" className={props.className || ''}>
		<g id="ALERT" transform="translate(465.842 465.842) rotate(180)">
			<path
				id="Path_5096"
				data-name="Path 5096"
				d="M232.921,0C104.488,0,0,104.49,0,232.922S104.488,465.842,232.921,465.842,465.842,361.355,465.842,232.922,361.353,0,232.921,0Zm0,423.493c-105.083,0-190.572-85.489-190.572-190.57S127.838,42.349,232.921,42.349s190.572,85.492,190.572,190.573S338,423.493,232.921,423.493Z"
			/>
			<path
				id="Path_5097"
				data-name="Path 5097"
				d="M173.229,70a28.233,28.233,0,1,0,28.227,28.246A28.268,28.268,0,0,0,173.229,70Z"
				transform="translate(59.689 28.815)"
			/>
			<path
				id="Path_5098"
				data-name="Path 5098"
				d="M171.175,140A21.175,21.175,0,0,0,150,161.175V288.222a21.175,21.175,0,1,0,42.349,0V161.175A21.175,21.175,0,0,0,171.175,140Z"
				transform="translate(61.746 57.63)"
			/>
		</g>
	</svg>
);
